module.exports = __webpack_public_path__ + "static/alpinist-black-43403b735d9506ca057926b693ef2b17.png";